import { Images } from '@/assets';
import CommonTitle from '@/components/title/CommonTitle';
import { fonts } from '@/theme/fonts';
import styled from 'styled-components';
import OrderCategory from './order-category/OrderCategory';
import { GetPartnerServiceOptionsResponse } from '@/api/type/types';
import { useTranslation } from 'react-i18next';
import { MultiLineText } from '@/components/text/MultiLineText';

interface VerifiedCenterRegistrationProps {
  data: GetPartnerServiceOptionsResponse[];
}
const VerifiedCenterRegistration = ({
  data,
}: VerifiedCenterRegistrationProps) => {
  const { t } = useTranslation();
  const r2QvdData = data.find((item) => item.serviceType === 'R2_QVD');
  const faveGuideData = data.find((item) => item.serviceType === 'FACE_GIDE');
  const megAlignerData = data.find(
    (item) => item.serviceType === 'MEG_ALIGNER'
  );

  const hasExclusiveService = r2QvdData || faveGuideData || megAlignerData;

  console.log('hasExclusiveService', hasExclusiveService);
  return (
    <Container $isActive={!!hasExclusiveService}>
      <TitleWrap>
        <CommonTitle
          imgUrl={
            Boolean(!!hasExclusiveService)
              ? Images.ActiveServiceAddIceon
              : Images.DisableServiceAddIcon
          }
          title={t('exclusiveCenterServiceRegistration')}
          color={Boolean(!!hasExclusiveService) ? '#000' : '#c6c2c2'}
        />
        <TitlePoint>Exclusive</TitlePoint>
      </TitleWrap>
      <ContentsSection>
        <TitleDesc $isActive={!!hasExclusiveService}>
          <MultiLineText
            translationKey={t(
              'theseServicesAreExclusivelyAvailableOnlyAtCertifiedCenters'
            )}
          />
        </TitleDesc>
        <CategorySection>
          <OrderCategory
            imgUrl={Images.QvdImg}
            title="R2 QVD"
            data={r2QvdData}
            desc={t('qvdDigitalDiagnostcServiceForEdentulousCases')}
            serviceType={'R2_QVD'}
          />
          <OrderCategory
            imgUrl={Images.FaceGideImg}
            title="Face GIDE"
            data={faveGuideData}
            desc={t('fromOrthognathicSurgeryToMaxillofacialProsthetics')}
            serviceType={'FACE_GIDE'}
          />
          <OrderCategory
            imgUrl={Images.MegAlignerImg}
            title="Meg Aligner"
            data={megAlignerData}
            desc={t('megAlignerClearAlignerServiceWithImplant')}
            serviceType={'MEG_ALIGNER'}
          />
        </CategorySection>
      </ContentsSection>
    </Container>
  );
};

export default VerifiedCenterRegistration;

const ContentsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 45px;
  padding-left: 61px;
`;

const TitleWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 748px;
`;

const TitlePoint = styled.div`
  padding: 6px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 99px;
  background: #121212;
  font-weight: ${fonts.weight.semiBold};
  font-size: 14px;
  line-height: 140%;
  color: #ffffff;
`;

const TitleDesc = styled.div<{ $isActive: boolean }>`
  font-size: 15px;
  line-height: 140%;
  color: ${({ $isActive }) => ($isActive ? '#000' : '#c6c2c2')};
  text-align: start;
`;

const CategorySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Container = styled.div<{ $isActive: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 14px;
  ${TitleDesc} {
    color: ${({ $isActive }) => ($isActive ? '#000' : '#c6c2c2')};
  }
`;
